import { Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ModalController } from '@ionic/angular';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { DateUtilsService } from 'src/app/modules/services/date-utils/date-utils.service';
import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { Historic } from '../../modal-historic/modal-historic.component';

@Component({
  selector: 'app-historico-analise',
  templateUrl: './historico-analise.component.html',
  styleUrls: ['./historico-analise.component.scss']
})
export class HistoricoAnaliseComponent {
  @Input() data: any;
  dataSource = new MatTableDataSource<any>([]);
  id!: string | null;
  highwayId!: string | null;
  segmentId!: string | null;
  documentId!: string | null;
  entitieId!: string | null;
  adressId!: string | null;
  contracId!: string | null;
  type !: string;
  paginatedHistorics: Historic[] = [];
  pageSize = 10;
  pageIndex = 0;
  totalElements = 0;
  totalPages = Math.ceil(this.totalElements / this.pageSize);
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  constructor(
    private snackbarService: OpenSnackbarService,
    private dateUtils: DateUtilsService,
    private loadingService: LoadingService,
    private modalCtrl: ModalController,
  ) {
    this.dataSource.data = this.data;
  }

    cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
    formatDateToReadable(isoDate: string): string {
    return this.dateUtils.formatDateToReadable(isoDate);
  }

}
